import React from 'react';

import Icons from 'assets/images/Icons';
import './WorkerStates.scss';

interface IStates {
  states: {
    workers_disabled: number
    workers_low: number
    workers_offline: number
    workers_ok: number
  }
}

const WorkerStates = ({
  states: {
    workers_disabled,
    workers_low,
    workers_offline,
    workers_ok,
  },
}: IStates) => (
  <div className='worker-states'>
    <h5>Worker States</h5>
    <div>
      <div title='OK'><h2><Icons className='ok' name='Check' />{workers_ok ?? 0}</h2></div>
      <div title='Low'><h2><Icons className='low' name='Down' />{workers_low ?? 0}</h2></div>
      <div title='Disabled'><h2><Icons className='dis' name='Exclamation' />{workers_disabled ?? 0}</h2></div>
      <div title='Offline'><h2><Icons className='off' name='Power' />{workers_offline ?? 0}</h2></div>
    </div>
  </div>
);

export default WorkerStates;
